import logo from "url:./images/beeldmerk.png";

export function Footer() {
  return (
    <div id="footer">
      <div id="gegevens">
        <ul>
          <li>
            <span>CodeRight</span>
            <br />
            Schumannstraat 1P
            <br />
            5654PE&nbsp;&nbsp;Eindhoven
          </li>
          <li>
            <span style={{ marginRight: "2px" }}>Bank&nbsp;</span>
            NL04 ABNA 0486 0307 25
            <br />
            <span>BTW&nbsp;&nbsp;</span>NL155362421B01
            <br />
            <span style={{ marginRight: "2px" }}>KVK&nbsp;&nbsp;</span>24369742
          </li>
          <li>
            <span>&#9742;&nbsp;</span>
            +31 6 1402 1890
            <br />
            <span style={{ marginLeft: "-2px", marginRight: "-2px" }}>
              &#127760;&nbsp;
            </span>
            www.coderight.nl
            <br />
            <span>&#9993;&nbsp;</span>
            info@coderight.nl
          </li>
        </ul>
      </div>

      <div id="beeldmerk">
        <a href="#top">
          <img src={logo} width="102" height="102" alt="Beeldmerk CodeRight" />
        </a>
      </div>

      <div id="copyright">Copyright &copy; 2025 - CodeRight</div>
    </div>
  );
}
